import { privateExperimentationUrl, publicExperimentationUrl } from 'config';
import createRequest from '../create-request';
import { urlToKey } from 'metrics';

const getExperiments = visitorId => {
  const request = createRequest({
    metricsApiKey: `${urlToKey(privateExperimentationUrl)}-participants`,
    label: 'experiments-participants'
  });

  const apiUrl = `${privateExperimentationUrl}/participants/${visitorId}`;

  return request
    .get(apiUrl)
    .timeout(80)
    .then(response => response.body);
};

const trackImpression = (experimentId, variation) => {
  const request = createRequest({
    metricsApiKey: `${urlToKey(publicExperimentationUrl)}-impression`,
    label: 'experiments-impression'
  });

  const apiUrl =
  `${publicExperimentationUrl}/experiments/${experimentId}/variations/${variation}/impressions`;

  return request
    .post(apiUrl)
    .then(response => response.body);
};

const trackConversion = (experimentId, variation) => {
  const request = createRequest({
    metricsApiKey: `${urlToKey(publicExperimentationUrl)}-conversion`,
    label: 'experiments-conversion'
  });

  const apiUrl =
  `${publicExperimentationUrl}/experiments/${experimentId}/variations/${variation}/conversions`;

  return request
    .post(apiUrl)
    .then(response => response.body);
};

export default {
  getExperiments,
  trackImpression,
  trackConversion
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/apis/experimentation.js
 **/